import React from "react";
import styles from "@/components/Login/Login.module.scss";
import { FormattedMessage } from "react-intl";
export function ErrorPage() {
    return (React.createElement("div", { className: styles.loginPage },
        React.createElement("h2", { className: styles.header },
            React.createElement(FormattedMessage, { defaultMessage: "Digital artbook & soundtrack", id: "jCTuVI", tagName: "span" })),
        React.createElement("div", { className: styles.panel },
            React.createElement("p", null,
                React.createElement(FormattedMessage, { defaultMessage: "Sorry, the service is unavailable.{br}{br}Please try again later.", id: "VWZadj", values: FormatP })))));
}
var FormatP = {
    br: React.createElement("br", null),
    b: function (content) { return React.createElement("b", null, content); },
};
